// Auto-generated file - do not edit manually
// Generated at build time with git information

export const BUILD_INFO = {
  "gitCommitHash": "84058a9b5431113e50ee4508582f62d5ad5865c6",
  "gitCommitShortHash": "84058a9",
  "gitBranch": "main",
  "buildNumber": "484",
  "buildTimestamp": "2026-07-25T18:44:40.437Z"
};
